<div class="vanguard-card">
  <div class="card-header">
    <div class="order-info">
      <div class="status-badge" [ngClass]="statusClass">
        {{statusLabel}}
      </div>
      <div class="order-meta">
        <span class="order-id">Pedido #{{pedidoH.idPedido}}</span>
        <span class="order-date">{{pedidoH.fecha}}</span>
      </div>
    </div>
    <div (click)="verDetalle()" class="action-link">
      Ver detalles
      <i class="mdi mdi-chevron-right link-icon" style="font-size: 1.2rem; color: var(--primary-color);"></i>
    </div>
  </div>

  <div class="card-body">
    <div class="products-preview">
      <div *ngFor="let art of articulosDePedido" class="product-thumb">
        <img class="img-fluid" [src]="art.getFotoImagen()" [alt]="art.nombre" loading="lazy">
      </div>
    </div>

    <div class="order-summary">
      <div class="price-box" *ngIf="!ocultarPrecios">
        <div class="total-price">{{pedidoH.monto | currency}}</div>
        <div class="flete-info" *ngIf="costoFlete">
          <span class="flete-label" *ngIf="costoFlete > 0">+ {{costoFlete | currency}} flete</span>
          <span class="flete-free" *ngIf="costoFlete <= 0">Envío Gratis</span>
        </div>
      </div>

      <div class="button-group">
        <button class="btn-repeat" (click)="repetirCompra()">
          Repetir Compra
        </button>
        <button class="btn-pay" (click)="pagar()" *ngIf="displayPagoDiferido !== 'none'">
          Pagar ahora
        </button>
      </div>
    </div>
  </div>
</div>